/*
 * M5.5 D3. develop's toggled row is a solid orange fill with a white label
 * (develop:platform/ui-next/src/utils/getToggledClassName.tsx); 3.13 spends orange as text
 * on a transparent row. text-primary is KEPT beside the fill: brand.css's .text-primary
 * paints it white and its [data-tool] > button.text-primary rule reads it as the toggled
 * discriminator. hover:!bg-muted is gone -- its !important beat DropdownMenuItem's
 * focus:bg-primary and held every MoreTools row navy on hover.
 */
const getToggledClassName = isToggled => {
  return isToggled ? 'bg-primary text-primary' : '!text-foreground/80 hover:text-highlight';
};

export { getToggledClassName };
